

















import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    accept: { type: String, default: undefined },
    multiple: { type: Boolean, default: false },
  },

  setup(_, { emit }) {
    const input = ref<HTMLInputElement>()

    const selectFile = (event: InputEvent) => {
      const target = event.target as HTMLInputElement

      if (!target.files) return

      emit('input', Array.prototype.slice.call(target.files))

      if (input.value) {
        input.value.value = ''
        input.value.files = null
      }
    }

    return { input, selectFile }
  },
})
